import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import CreateGroup from '../pages/groups/CreateGroup';
import EditGroup from '../pages/groups/EditGroup';
import Groups from '../pages/groups/Groups';
import ContentRoutes from '../routes/ContentRoutes';

import '../../css/routes/group-routes.css';

class GroupRoutes extends Component {
  render() {
    const { match } = this.props;
    sessionStorage.setItem('channelId', match.params.channelId);

    return (
      <div style={{ height: '100%' }}>
        <Switch>
          <Route exact path="/channel/:channelId/groups" component={Groups} />
          <Route
            exact
            path="/channel/:channelId/groups/create"
            component={CreateGroup}
          />
          <Route
            exact
            path="/channel/:channelId/groups/:groupName/edit"
            component={EditGroup}
          />
          <Route
            path="/channel/:channelId/groups/:groupName"
            component={ContentRoutes}
          />
        </Switch>
      </div>
    );
  }
}

export default GroupRoutes;
